import request from 'config/axios'

const getIrrfURL = ({ transactionType, accountType, startDate, endDate }) =>
  `gringott/incomeTax/${accountType}/${transactionType}?startDate=${startDate}&endDate=${endDate}`

const getDownloadURL = ({ transactionType, accountType, startDate, endDate, fileType }) =>
  `gringott/incomeTax/report/${accountType}/${transactionType}?startDate=${startDate}&endDate=${endDate}&format=${fileType}`  // eslint-disable-line

const configs = {
  responseType: 'arraybuffer'
}

export const getIrrfReport = ({ payload }) => request.get(getIrrfURL(payload))
export const getIrrfDownload = ({ payload }) => (
  request.get(getDownloadURL(payload), configs)
)
